import MutasiAntarGudangApi from './MutasiAntarGudangApi';

export default MutasiAntarGudangApi;
